import React from 'react';

import Icon from '@ey/canvascoreservices/Icon';
import OutputText from '@ey/canvascoreservices/OutputText';
import {actionIcInfo24px} from '@ey/motif-react-wrapper/assets/icons/index';
import StyledLinkInfo from './StyledLinkInfo';

export default function LinkInfo({labels}) {
	const iconProps = {
		src: actionIcInfo24px,
		className: 'info-link-icon'
	};

	return (
		<StyledLinkInfo className="instructional">
			<Icon {...iconProps} />
			<OutputText>{labels.editLinkInfo}</OutputText>
		</StyledLinkInfo>
	);
}
